import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { CalendarInputComponent } from './calendar-input/calendar-input.component';
import { CalendarPopoverComponent } from './calendar-popover/calendar-popover.component';
import { CheckComponent } from './check/check.component';
import { InputFileComponent } from './input-file/input-file.component';
import { InputCaptionComponent } from './input-caption/input-caption.component';
import { InputComponent } from './input/input.component';
import { SelectOptionComponent } from './select-option/select-option.component';
import { SelectPopoverComponent } from './select-popover/select-popover.component';
import { SelectComponent } from './select/select.component';
import { TextareaComponent } from './textarea/textarea.component';
import { LayoutModule } from '../layout/layout.module';
import { InputCameraComponent } from './input-camera/input-camera.component';


@NgModule({
  declarations: [
    CalendarInputComponent,
    CalendarPopoverComponent,
    CheckComponent,
    InputComponent,
    InputCaptionComponent,
    InputCameraComponent,
    InputFileComponent,
    SelectComponent,
    SelectOptionComponent,
    SelectPopoverComponent,
    TextareaComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    PipesModule,
    RouterModule,
    LayoutModule,
    ScrollingModule
  ],
  exports: [
    CalendarInputComponent,
    CalendarPopoverComponent,
    CheckComponent,
    InputComponent,
    InputCaptionComponent,
    InputCameraComponent,
    InputFileComponent,
    SelectComponent,
    SelectOptionComponent,
    SelectPopoverComponent,
    TextareaComponent
  ]
})
export class InputModule { }
